/**
 * Sets and exports the turnTo configuration options. Assumes that this is
 * called after the client sets `window.turnToConfig`.
 */
const fullTurnToConfig: IWindowTurnToConfig = window.turnToConfig || {}

/**
 * Holds the hosts configuration for the deployment.  While most all values are a host name,
 * there are some others that do not change and are not to be manually set by the client,
 * such as siteKey.
 * This file does allow for manual configuration for qa and dev builds. In fact, dev should
 * be overriden, qa does not need to be.
 */
interface IHostsConfig {
  protocol: string
  cdnHost: string
  originHost: string
  widgetsHost: string
  imageStoreBase: string
  moderationHost: string
  siteKey: string
  analyticsHost: string
}

let hostsConfig: IHostsConfig

if (process.env.NODE_ENV === 'development' || process.env.testProdBuild) {
  hostsConfig = {
    protocol: fullTurnToConfig.protocol || 'http',
    cdnHost: fullTurnToConfig.cdnHost || 'localhost:9999',
    originHost: fullTurnToConfig.originHost || 'localhost:9999',
    widgetsHost: fullTurnToConfig.widgetsHost || 'localhost:9999',
    imageStoreBase: fullTurnToConfig.imageStoreBase || 'dev-images.turntodev.com',
    moderationHost: fullTurnToConfig.moderationHost || 'dev.turntodev.com',
    siteKey: fullTurnToConfig.siteKey || 'DeaequNgimr7koRsite',
    analyticsHost: 'https://nqes4ybiuf.execute-api.us-east-1.amazonaws.com/dev/event'
  }
} else {
  if (process.env.forQa && process.env.region === 'us1') {
    hostsConfig = {
      protocol: fullTurnToConfig.protocol || 'https',
      cdnHost: fullTurnToConfig.cdnHost || 'qa-cdn-ws.turntodev.com',
      originHost: fullTurnToConfig.originHost || 'qa-ws.turntodev.com',
      widgetsHost: fullTurnToConfig.widgetsHost || 'qa-widgets.turntodev.com',
      imageStoreBase: fullTurnToConfig.imageStoreBase || 'qa-images.turntodev.com',
      moderationHost: fullTurnToConfig.moderationHost || 'qa.turntodev.com',
      siteKey: BUILD_SITE_KEY,
      analyticsHost: 'https://qa-webevents.turntodev.com/event'
    }
  } else if (process.env.forStaging && process.env.region === 'us1') {
    hostsConfig = {
      protocol: 'https',
      cdnHost: 'staging-cdn-ws.turntodev.com',
      originHost: 'staging-ws.turntodev.com',
      widgetsHost: 'staging-widgets.turntodev.com',
      imageStoreBase: 'staging-images.turntodev.com',
      moderationHost: 'staging.turntodev.com',
      siteKey: BUILD_SITE_KEY,
      analyticsHost: 'https://staging-webevents.turntodev.com/event'
    }
  } else if (process.env.region === 'us1') {
    hostsConfig = {
      protocol: 'https',
      cdnHost: 'cdn-ws.turnto.com',
      originHost: 'ws.turnto.com',
      widgetsHost: 'widgets.turnto.com',
      imageStoreBase: 'images.turnto.com',
      moderationHost: fullTurnToConfig.moderationHost || 'www.turnto.com',
      siteKey: BUILD_SITE_KEY,
      analyticsHost: 'https://we.turnto.com/event'
    }
  } else if (process.env.region === 'eu1') {
    hostsConfig = {
      protocol: 'https',
      cdnHost: 'cdn-ws.turnto.eu',
      originHost: 'ws.turnto.eu',
      widgetsHost: 'widgets.turnto.eu',
      imageStoreBase: 'images.turnto.eu',
      moderationHost: fullTurnToConfig.moderationHost || 'www.turnto.eu',
      siteKey: BUILD_SITE_KEY,
      analyticsHost: 'https://we.turnto.eu/event'
    }
  }
}

/**
 * making sure locale is set for case where not specified
 */
if (!fullTurnToConfig.locale) {
  fullTurnToConfig.locale = process.env.defaultLocale || 'en_US'
}

// this narrows the scope of turnToConfig to exclude the hostsConfig. Doing this to a
// typescript error will happen if trying to access a hostsConfig property like siteKey
const turnToConfig = fullTurnToConfig as ITurnToConfig

export { turnToConfig, hostsConfig }
